var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import queryString from 'query-string';
import { PureComponent } from 'react';
import { EmailPage } from '../EmailPage';
import { EmailCsatSettingTabs } from '../EmailPage/EmailPage';
import { EmailCSAT } from '../EmailPage/types';
import { formatEmailCustomisationFormValuesForApi } from './utilities';
export const initiallyActiveTabQueryParamName = 'initiallyActiveTab';
export class EmailPanel extends PureComponent {
    componentDidMount() {
        this.props.loadEmailSettingsAllLevels();
        this.props.loadAllEmails();
    }
    getEnrichedLanguagesWithSettings() {
        return this.props.languagesSettings.list.map(({ code, label, settings }) => {
            var _a;
            return ({
                isSetup: settings !== null,
                ratingStyle: (_a = settings === null || settings === void 0 ? void 0 : settings.customization.look_and_feel) !== null && _a !== void 0 ? _a : undefined,
                enabled: (settings === null || settings === void 0 ? void 0 : settings.enabled) || false,
                name: label,
                code,
                settings,
            });
        });
    }
    redirectToLanguageCustomizationPage(language) {
        var _a;
        const pathname = language.isSetup
            ? `/settings/satisfaction/email/${language.code}/edit/${(_a = language.settings) === null || _a === void 0 ? void 0 : _a.id}`
            : `/settings/satisfaction/email/${language.code}/create/`;
        this.props.navigate({ pathname });
    }
    getGlobalSettingsInitialValues() {
        var _a;
        const { delay = '', sender_email = '', reply_to_email = '', } = ((_a = this.props.globalSettings.values) === null || _a === void 0 ? void 0 : _a.customization) || {};
        return {
            delay: delay === null || delay === void 0 ? void 0 : delay.toString(),
            senderEmail: sender_email,
            replyToEmail: reply_to_email,
        };
    }
    handleSaveGlobalSettings(formValues) {
        if (this.isEmailCsatSetup()) {
            this.editGlobalSettings(formValues);
        }
    }
    editGlobalSettings(formValues) {
        if (!this.props.globalSettings.values)
            return;
        const customization = formatEmailCustomisationFormValuesForApi(formValues);
        if (customization) {
            this.props.updateGlobalSettings(Object.assign(Object.assign({}, this.props.globalSettings.values), { customization }));
        }
    }
    handleGlobalStatusChange(change) {
        // If we have global settings already, update it
        if (this.props.globalSettings.values) {
            this.props.updateGlobalSettings(Object.assign(Object.assign({}, this.props.globalSettings.values), { enabled: change.newStatus }));
        }
        else {
            // Otherwise csat is not initialized, so initialize if needed.
            if (change.newStatus === true) {
                this.props.initializeEmailCsat();
            }
        }
    }
    handleLanguageStatusChange({ language, newStatus, }) {
        var _a;
        // the default language should not be allowed to be disabled.
        if (EmailCSAT.defaultLanguage === language.code) {
            return;
        }
        const payload = {
            id: (_a = language.settings) === null || _a === void 0 ? void 0 : _a.id,
            enabled: newStatus,
            channel: 'email',
        };
        this.props.updateLanguageLevelSettings(payload);
    }
    isEmailCsatActive() {
        var _a;
        return ((_a = this.props.globalSettings.values) === null || _a === void 0 ? void 0 : _a.enabled) || false;
    }
    isEmailCsatSetup() {
        return Boolean(this.props.globalSettings.values);
    }
    isLoadingGlobalSettings() {
        return this.props.globalSettings.asyncStatus === 'loading';
    }
    isLoadingEmailLevelSettings() {
        return this.props.emailAccountsSettings.asyncStatus === 'loading';
    }
    getInitiallyActiveTab() {
        let { initiallyActiveTab } = queryString.parse(this.props.location.search);
        if (Array.isArray(initiallyActiveTab)) {
            initiallyActiveTab = initiallyActiveTab[0];
        }
        const cleanedUpValue = initiallyActiveTab === null || initiallyActiveTab === void 0 ? void 0 : initiallyActiveTab.trim().toLowerCase();
        if (!cleanedUpValue) {
            return EmailCsatSettingTabs.Accounts;
        }
        switch (cleanedUpValue) {
            case EmailCsatSettingTabs.Accounts.toLowerCase():
                return EmailCsatSettingTabs.Accounts;
            case EmailCsatSettingTabs.Customizations.toLowerCase():
                return EmailCsatSettingTabs.Customizations;
            default:
                return EmailCsatSettingTabs.Accounts;
        }
    }
    render() {
        return (_jsx(EmailPage, { onGlobalStatusChange: this.handleGlobalStatusChange, isEmailCsatActive: this.isEmailCsatActive(), isEmailCsatSetup: this.isEmailCsatSetup(), globalSettingsInitialValue: this.getGlobalSettingsInitialValues(), onSettingsSave: this.handleSaveGlobalSettings, existingEmails: this.props.emailAccountsSettings.list, onAccountStatusChange: this.props.updateEmailLevelSettings, isLoadingEmailsList: this.isLoadingEmailLevelSettings(), languages: this.getEnrichedLanguagesWithSettings(), onLanguageStatusChange: this.handleLanguageStatusChange, onLanguageEdit: this.redirectToLanguageCustomizationPage, isLoadingGlobalSettings: this.isLoadingGlobalSettings(), defaultLanguage: EmailCSAT.defaultLanguage, initiallyActiveTab: this.getInitiallyActiveTab() }));
    }
}
__decorate([
    boundMethod
], EmailPanel.prototype, "redirectToLanguageCustomizationPage", null);
__decorate([
    boundMethod
], EmailPanel.prototype, "handleSaveGlobalSettings", null);
__decorate([
    boundMethod
], EmailPanel.prototype, "handleGlobalStatusChange", null);
__decorate([
    boundMethod
], EmailPanel.prototype, "handleLanguageStatusChange", null);
